import React, { useMemo } from 'react';
import styles from '../../../assets/styles/training.module.scss';
import { AdminTrainingContainer, UserTrainingContainer } from '../components';
import Organization from 'infrastructure/Organization';
import { useSalesRepView } from 'features/salesRepView/SalesRepView.hook';
import ModuleAssessmentResults from '../assessment/ModuleBased/ModuleAssessmentResults';
import AnswerModuleAssessment from '../assessment/ModuleBased/AnswerModuleAssessment';
import { useGetFF } from '@fstack-tech/ff_react_module';

const Training = ({ role }) => {
  const { isActive, isLoading } = useSalesRepView();
  const { isEnabled: ff_learning_paths } = useGetFF({ flag_id: 'learning_paths' });
  const { isEnabled: ff_skill_paths_dashboards } = useGetFF({ flag_id: 'skill_paths_dashboards' });

  const slug = useMemo(() => {
    if (isActive) return Organization.ROLES.REP;
    return role?.slug;
  }, [role, isActive]);

  const showRepContainer = useMemo(() => {
    if (isActive) return true;
    return slug === Organization.ROLES.REP;
  }, [isActive, slug]);

  if (isLoading) return null;
  return (
    <div className={styles.trainingPage}>
      {showRepContainer ? (
        <UserTrainingContainer role={slug} ff_skill_paths_dashboards={ff_skill_paths_dashboards}/>
      ) : (
        <AdminTrainingContainer role={role?.slug} ff_learning_paths={ff_learning_paths} ff_skill_paths_dashboards={ff_skill_paths_dashboards}/>
      )}
      <ModuleAssessmentResults />
      <AnswerModuleAssessment /> 
    </div>
  );
};

export default Training;
